import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomysoreootybustour() {



  const cardData =
  {
    keyword: 'Pune to Mysore Ooty Bus Tour Package',
    heading: 'Sanavi Travels: Pune to Mysore Ooty Bus Tour Package',
    headingDescription: 'Sanavi Travels offers well-planned Pune to Mysore Ooty Bus Tour Package, providing safe, comfortable, and enjoyable group travel for families, tourists, corporate groups, and pilgrimage travelers exploring South India’s most popular destinations. Our fleet of well-maintained AC and non-AC luxury buses ensures spacious seating, smooth suspension, and a relaxed long-distance journey. With experienced drivers, professionally managed tour itineraries, flexible group packages, transparent pricing, and 24/7 support, Sanavi Travels guarantees a hassle-free and memorable travel experience. The tour covers major attractions including Mysore Palace, Chamundi Hills, Brindavan Gardens, Ooty Botanical Garden, Doddabetta Peak, Coonoor, and scenic hill routes, with convenient boarding points across Pune. Choose Sanavi Travels for trusted Pune to Mysore Ooty bus tour packages, delivering comfort, safety, and a delightful South India tour experience.',

    top: 'Top Places to Visit in Mysore with Sanavi Travels',


"topPlaces": [
  {
    "title": "Mysore Palace",
    "description": "Mysore Palace is the iconic royal residence of the Wadiyar dynasty, renowned for its Indo-Saracenic architecture, ornate interiors, and grand Durbar Hall. Illuminated on weekends and during festivals, it attracts thousands of visitors who marvel at its grandeur and cultural significance."
  },
  {
    "title": "Chamundi Hill and Chamundeshwari Temple",
    "description": "Chamundi Hill is a prominent landmark overlooking Mysore, housing the Chamundeshwari Temple dedicated to Goddess Chamundi. Visitors can climb the 1,000 steps or drive up to the hilltop for panoramic views of the city and the Nandi Bull statue at the base."
  },
  {
    "title": "Brindavan Gardens",
    "description": "Brindavan Gardens, located near the Krishnarajasagara Dam, is famous for its symmetric terraces, musical fountains, and beautifully landscaped gardens. Evening light and music shows make it a must-visit for families and tourists."
  },
  {
    "title": "St. Philomena’s Church",
    "description": "St. Philomena’s Church is a majestic neo-Gothic church in Mysore, inspired by the Cologne Cathedral. It features impressive stained-glass windows, tall spires, and peaceful interiors, attracting visitors for both worship and architecture."
  },
  {
    "title": "Mysore Zoo (Sri Chamarajendra Park)",
    "description": "Mysore Zoo is one of India’s oldest and well-maintained zoos, home to a wide variety of animals, birds, and reptiles. It focuses on conservation and education, making it ideal for families and wildlife enthusiasts."
  },
  {
    "title": "Jaganmohan Palace and Art Gallery",
    "description": "Jaganmohan Palace is a historic palace converted into an art gallery featuring traditional and contemporary Indian artworks, royal artifacts, and paintings. It is an important cultural center for art lovers visiting Mysore."
  },
  {
    "title": "Rail Museum, Mysore",
    "description": "Mysore Rail Museum showcases vintage locomotives, carriages, and railway memorabilia. It offers a nostalgic journey into India’s railway history and is especially popular among children and railway enthusiasts."
  },
  {
    "title": "Karanji Lake",
    "description": "Karanji Lake is a scenic urban lake surrounded by a butterfly park and aviary. Visitors can enjoy boating, birdwatching, and peaceful walks along the landscaped paths, making it a relaxing nature retreat within the city."
  },
  {
    "title": "Ranganathittu Bird Sanctuary",
    "description": "Located near Mysore, Ranganathittu Bird Sanctuary is home to numerous migratory and resident bird species. It offers boat rides and birdwatching opportunities, making it a haven for nature lovers and photographers."
  },
  {
    "title": "Devaraja Market",
    "description": "Devaraja Market is a bustling local market in Mysore, known for colorful flowers, spices, handicrafts, and traditional Mysore silk. It provides an authentic glimpse into local culture, commerce, and daily life."
  }
]
,




"services": [
  {
    "name": "Pune to Mysore Ooty Bus Tour Package",
    "description": "Pune to Mysore Ooty Bus Tour Package offers comfortable and organized bus tours for travelers visiting Mysore and Ooty."
  },
  {
    "name": "Mysore Ooty Tour Bus Pune",
    "description": "Mysore Ooty Tour Bus Pune provides reliable bus services for sightseeing and leisure trips between Pune, Mysore, and Ooty."
  },
  {
    "name": "AC Bus Mysore Ooty",
    "description": "AC Bus Mysore Ooty ensures a cool and comfortable journey with fully air-conditioned buses for long-distance travel."
  },
  {
    "name": "Luxury Bus Mysore Ooty Tour",
    "description": "Luxury Bus Mysore Ooty Tour offers premium buses with advanced comfort features for a relaxing and stylish travel experience."
  },
  {
    "name": "Family Bus Tour Mysore Ooty",
    "description": "Family Bus Tour Mysore Ooty provides spacious and safe buses for family trips, ensuring comfort and convenience."
  },
  {
    "name": "Group Travel Bus Mysore Ooty",
    "description": "Group Travel Bus Mysore Ooty specializes in transporting groups efficiently for leisure or corporate tours."
  },
  {
    "name": "Affordable Bus Package Mysore Ooty",
    "description": "Affordable Bus Package Mysore Ooty offers budget-friendly bus tours without compromising on comfort or safety."
  },
  {
    "name": "Chauffeur Driven Bus Tour",
    "description": "Chauffeur Driven Bus Tour ensures stress-free travel with professional drivers managing routes and schedules."
  },
  {
    "name": "Best Mysore Ooty Bus Tour Pune",
    "description": "Best Mysore Ooty Bus Tour Pune provides top-quality bus tours with reliable service and comfortable vehicles."
  },
  {
    "name": "Pune South India Bus Tour",
    "description": "Pune South India Bus Tour offers organized travel packages to South India destinations with comfortable buses and professional drivers."
  },
  {
    "name": "Tourist Bus Mysore Ooty",
    "description": "Tourist Bus Mysore Ooty provides convenient transportation for sightseeing and tourist trips between Mysore and Ooty."
  },
  {
    "name": "Hill Station Bus Tour Pune",
    "description": "Hill Station Bus Tour Pune offers comfortable bus travel to hill stations with scenic routes and safe driving."
  },
  {
    "name": "Long Distance Bus Tour Pune",
    "description": "Long Distance Bus Tour Pune specializes in intercity and interstate travel with well-maintained buses and experienced drivers."
  },
  {
    "name": "Holiday Bus Package Pune",
    "description": "Holiday Bus Package Pune provides organized bus tours for vacations and holiday trips with comfortable seating and safety."
  },
  {
    "name": "Mysore Ooty Travel Bus",
    "description": "Mysore Ooty Travel Bus offers reliable bus transport for travelers visiting Mysore and Ooty, ensuring comfort and timely travel."
  }
],
"tableData": [
  ["Pune to Mysore Ooty Bus Tour Package", "Mysore Ooty Tour Bus Pune"],
  ["AC Bus Mysore Ooty", "Luxury Bus Mysore Ooty Tour"],
  ["Family Bus Tour Mysore Ooty", "Group Travel Bus Mysore Ooty"],
  ["Affordable Bus Package Mysore Ooty", "Chauffeur Driven Bus Tour"],
  ["Best Mysore Ooty Bus Tour Pune", "Pune South India Bus Tour"],
  ["Tourist Bus Mysore Ooty", "Hill Station Bus Tour Pune"],
  ["Long Distance Bus Tour Pune", "Holiday Bus Package Pune"],
  ["Mysore Ooty Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mysore Ooty Bus Tour Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers an exciting and comfortable Pune to Mysore Ooty bus tour package, perfect for family trips, friends’ outings, and sightseeing tours."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced buses for a smooth and enjoyable journey from Pune to Mysore and Ooty."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, experienced, and familiar with the Pune to Mysore Ooty route to ensure safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Mysore Ooty bus tour packages, inclusive of fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your tour."
  },
  {
    "WhyChooseheading": "Flexible Tour Packages",
    "WhyChoosedescription": "Choose from customized tour itineraries, one-way, round-trip, or multi-day packages based on your Pune to Mysore Ooty travel plans."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Buses",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mysore Ooty bus tours."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer Pune to Mysore Ooty bus tour packages?',
    answer: 'Yes, Sanavi Travels provides comfortable and exciting bus tour packages from Pune to Mysore and Ooty.'
  },
  {
    question: 'How can I book the Pune to Mysore Ooty bus tour?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are used for the tour?',
    answer: 'Sanavi Travels provides air-conditioned and well-maintained buses suitable for long-distance tours.'
  },
  {
    question: 'Are drivers experienced with the Pune to Mysore Ooty route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the entire tour route.'
  },
  {
    question: 'Can I customize my tour itinerary?',
    answer: 'Absolutely. You can customize routes, stops, and the tour duration according to your preferences.'
  },
  {
    question: 'Is the bus tour service available 24x7?',
    answer: 'Yes, Sanavi Travels offers support and assistance throughout your Pune to Mysore Ooty tour.'
  },
  {
    question: 'Are the buses sanitized before the tour?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'What payment options are available for the tour?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Mysore Ooty tour.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'Booked the Pune to Mysore Ooty bus tour. Comfortable journey, professional service, and memorable sightseeing experience.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shweta Patil',
    feedback: 'Excellent bus tour from Pune to Mysore and Ooty. The buses were clean, and the staff was very supportive throughout the trip.',
    rating: 5
  }
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mysore Ooty Bus Tour Package - Sanavi Travels",
  "description": "Book Pune to Mysore Ooty bus tours with Sanavi Travels. AC and luxury buses for family trips, group travel, hill station tours, long-distance travel, holiday excursions, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Pune to Mysore Ooty Bus Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses from Pune to Mysore and Ooty with Sanavi Travels. Perfect for family trips, group travel, hill station tours, long-distance travel, holiday excursions, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomysoreootybustour;